export const formatAddress = (address) => {
  const {
    street = '', aptNumber = '', state = '', zipCode = '', city = ''
  } = address;

  return `${aptNumber} ${street}, ${city}, ${state} ${zipCode}`;
};

export const formatLocation = (address) => {
  const region = address.address_components && address.address_components.find((item) => item.types.find((type) => type === 'administrative_area_level_2'))?.short_name;
  const state = address.address_components && address.address_components.find((item) => item.types.find((type) => type === 'administrative_area_level_1'))?.short_name;
  const city = address.address_components && address.address_components.find((item) => item.types.find((type) => type === 'locality'))?.long_name;

  return (city && state) ? ` - ${region ? `${region}, ` : ''} ${city}, ${state}` : '';
};
